<template>
  <svg :class="svgClass" aria-hidden="true" :width="size" :height="size" :fill="color" :stroke="color">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: 'svgIcon',
  props: {
    iconId: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '0.24rem'
    },
    color: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName () {
      return `#lz-svg-${this.iconId}`
    },
    svgClass () {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    }
  }
}
</script>

<style scoped>
.svg-icon {
  vertical-align: -0.15em;
  overflow: hidden;
}
</style>
